export default {"src":"/_next/static/media/5.69d11767.svg","height":39,"width":39,"blurWidth":0,"blurHeight":0};